module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/array/from.js
// module id = 358
// module chunks = 35783957827783 114276838955818 120561760088751 199672004568253